export default __webpack_public_path__ + "static/media/adapt.c6de5294.svg";